
<appbar (myEvent)="refreshPage()" [customBack]="goToCustomRoute">{{ gameName }}</appbar>
<div class="main__wrapper">  
  <div class="header">
    <!--Content before waves-->
    <div class="row" *ngIf="!isUserLoggedIn">
      <div class="col-12 my-2 text-left">
        <a (click)="loginAccount()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <div style="align-items:center">
            <ion-icon name="person-circle-outline" style="vertical-align:middle ;margin-right:10px"
              class="account-login">
            </ion-icon>
            <span class="account_login_text">{{ 'click_to_login' | translate}}</span>
          </div>
        </a>

      </div>
    </div>

    <div style="padding: 10px 15px;" *ngIf="isUserLoggedIn">
      <a [routerLink]="['/wallet/game-wallet',providerId]" replaceUrl="true" [state]="{parentLink: gameLink}">
        <div class="card" style="background: transparent !important; ">
          <div class="card-body" style="margin: 0px !important; padding: 0px !important;">
            <div class="row">
              <div class="col-8">
                <div class="row walletlbl">
                  <div class="col-12 ml-auto" style="display: flex;">
                    <ion-icon name="wallet-outline" class="active-wallet"></ion-icon>
                    <!-- <img src = './assets/img/activewallet.png'  class="active-wallet"/> -->
                    <span class="child-walletlbl pt-1">{{ 'mainWallet' | translate}} &nbsp;&nbsp;&nbsp;
                      {{userProfileBalance | number : 0}}</span>

                  </div>
                </div>

                <div class="row walletlbl">
                  <div class="col-12 ml-auto" style="display: flex;">
                    <img src='./assets/img/game_wallet.png' class="active-wallet" />
                    <span class="child-walletlbl pt-1">{{ gameName }}({{ 'ks' | translate}}) &nbsp;&nbsp;&nbsp;
                      {{gameUserBalance}}</span>

                  </div>

                </div>
              </div>
              <div class="col-4 " style="height: 100%;">
                <div class="row"
                  style="height: 100% !important; margin-top: 20% !important; justify-content: right !important;">
                  <ion-icon name="chevron-forward-outline" style="font-size: 30px; color: #fff !important;"></ion-icon>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="slider">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngIf="adsList != ''">
          <ng-template carouselSlide *ngFor="let adsObj of adsList">
            <div class="slide">
              <img [src]="adsObj.imageUrl" alt="AdsImage">
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

      <div class="overlay" *ngIf="marqueeText != null">
        <marquee direction="left">
          <h5>{{marqueeText.marqueeText}}</h5>
        </marquee>
      </div>
    </div>
    <!--Waves Container-->
    <div>
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
          <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
          <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
      </svg>
    </div>
    <!--Waves end-->
  </div>
  <!-- end header --> 
   <div class="container">   
     
      <div class="row" *ngIf="gameList != null && gameList.isMaintenance == false && gameList.status == 'ACTIVE'">
         <div class="col-12 text-center px-5 my-2 game-searching" *ngIf=" gameItems.length > 10">         
          <input type="text" placeholder="Search.." (keyup)="search()" [(ngModel)]="searchKey"
            [ngModelOptions]="{standalone: true}" >
          <ion-icon name="search-outline"></ion-icon>
        </div>
       
        <div class="col-4 game__items" *ngFor="let gameObj of gameItems;trackBy: trackByItems;">
          <img [src]="gameObj.iconurl" [alt]="gameObj.name"
            (click)='showplayFreeOrplay(playFreeOrPlay,transferAlert,gameObj.supportdemourl,gameObj.code,gameObj.providercode,gameObj)'>
          <h5>{{ changeLanguage(gameObj)}}</h5>
        </div>
       
      </div>      

      <!-- App Maintain Capsule -->
      <div class="row text-center" *ngIf="gameList != null  && gameList.isMaintenance == true && gameAlertObject.status =='ACTIVE' && gameAlertObject !=null" >
          <img [src]='gameList.titleimageUrl'
          *ngIf="(gameList.titleimageUrl !=null && gameList.titleimageUrl?.length > 0)" class="gameTitleImgClass">
            <div class="col-12 maintenanceClass pt-2">
              <img *ngIf="(gameAlertObject.imageUrl == null && gameAlertObject.imageUrl?.length == 0)"
                src='./assets/img/maintenance.png' width="100px" height="100px" />
              <img *ngIf=" (gameAlertObject.imageUrl != null && gameAlertObject.imageUrl?.length != 0)"
                [src]='gameAlertObject.imageUrl' width="100px" height="100px" class='gameAlertImg' />
              <p>{{gameAlertObject.description_en}}</p>
            </div>            
      </div>    
      <!-- * App Maintain Capsule -->
   </div>   
</div>
<!-- * end App Capsule -->

<!-- Pls topup alert -->
<ng-template #transferAlert>  
  <div class="modal-body">    
    <div class="container py-3 position-relative">
      <ion-icon name="close-circle" (click)="HideAlert()" class="close"></ion-icon>
      <div class="text-center">
        <ion-icon name="warning" class="warning"></ion-icon>
      </div>
      <p class="text-center my-2">{{ 'gametransactionAlert' | translate}}</p>
      <div class="d-flex align-items-center mb-3">
        <img src='./assets/img/game_kyat.png' class="active-wallet" />
        <span class="child-walletbalance">{{ 'mainWallet' | translate}} &nbsp;&nbsp;&nbsp; {{userProfileBalance |
          number : 0}}</span>
      </div>
      <div class="d-flex align-items-center">
        <img src='./assets/img/game_wallet.png' class="active-wallet" />
        <span class="child-walletbalance">{{ 'gameWallet' | translate}} &nbsp;&nbsp;&nbsp;
          {{gameUserBalance}}</span>

      </div>
      <div class="row justify-content-between pt-3">
        <button type="button" class="btn btn-secondary btnGroup" (click)="openGame('free')">{{ 'game_view' | translate}}</button>
        <button type="button" class="btn btn-primary btnGroup" (click)="goToGameWallet()">{{ 'game_balance_transfer' | translate}}</button>
      </div>
    </div>
  </div>

</ng-template>

<!-- playFreeOrPlay alert use this -->
<ng-template #playFreeOrPlay> 
  <div class="modal-body">
    <div class="container position-relative">
       <ion-icon name="close-circle" (click)="HidePlayFreeOrPlayAlert()" class="close"></ion-icon>
      <div class="row py-2">
        <button type="button" class="btn btn-block mx-3" data-dismiss="modal" (click)="playFree()"
          style="background: #000; color: #fff;margin: 20px 0px;">
          <ion-icon name="play-circle-outline"></ion-icon>&nbsp;{{ 'play_free' | translate}}
        </button>
        <button type="button" class="btn btn-success btn-block  mx-3" (click)="play(transferAlert)">
          <ion-icon name="play-circle-outline"></ion-icon> &nbsp;{{ 'play' | translate}}
        </button>
      </div>
    </div>
   
  </div>
  
</ng-template>

<!-- * Game maintenance Alert -->
 <ng-template #maintenanceAlert>  
  <div class="modal-body">    
    <div class="container py-3 position-relative">
      <ion-icon name="close-circle" (click)="HideMaintenanceAlert()" class="close"></ion-icon>
       <div class="text-center">
          <img [src]='gameAlertObject.imageUrl' class="gameAlertImgClass" width="80px" loading="lazy">
        </div>
        <p class="text-center">{{gameAlertObject.description_en}}.</p>
    </div>
  </div>
</ng-template>
<ngx-spinner name="refreshLoading" bdOpacity=0.9 size="medium" color="#00acc1" type="ball-spin-clockwise"
  [fullScreen]="true"></ngx-spinner>